import { useCallback, useMemo } from 'react';
import { useToggle as useToggleTs } from 'usehooks-ts';

export const useToggle = (initialValue: boolean = false) => {
  const [value, toggle, setValue] = useToggleTs(initialValue);
  const toggleOff = useCallback(() => setValue(false), [setValue]);
  const toggleOn = useCallback(() => setValue(true), [setValue]);

  const useToggleResult = useMemo(
    () => ({
      isOn: value,
      setToggle: setValue,
      toggle,
      toggleOff,
      toggleOn,
    }),
    [value, setValue, toggle, toggleOff, toggleOn],
  );

  return useToggleResult;
};
